import React, { useState } from 'react';
import useDisplayBanner from '../hooks/useDisplayBanner';
import style from './SurveyPageShared.module.scss';

const valuableOptions = [
  'Invoice factoring / financing',
  'Revenue-based financing',
  'Working capital loans',
  'Credit lines tied to receivables',
  'Trade credit / supplier financing',
  'Cash flow forecasting integrated with funding',
];

const CapitalPlaceholder = () => {
  const [usingProvider, setUsingProvider] = useState('');
  const [providerName, setProviderName] = useState('');
  const [preferInChaser, setPreferInChaser] = useState('');
  const [valuable, setValuable] = useState([]);
  const [otherValuable, setOtherValuable] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const showBanner = useDisplayBanner();

  const canSubmit = Boolean(usingProvider && preferInChaser);

  const toggleValuable = (option) => {
    setValuable(prev => (
      prev.includes(option) ? prev.filter(item => item !== option) : [...prev, option]
    ));
  };

  const onSubmit = (e) => {
    e.preventDefault();
    if (!canSubmit) return;

    const payload = {
      signals: [
        `Q1: ${usingProvider}${usingProvider === 'Yes' && providerName ? ` (${providerName})` : ''}`,
        `Q2: ${preferInChaser}`,
        `Q3: ${[...valuable, otherValuable ? `Other: ${otherValuable}` : ''].filter(Boolean).join('; ') || 'none selected'}`,
      ].join('\\n'),
      category: 'Survey',
      productCategory: 'Working Capital',
      sentiment: 'Not applicable',
      status: 'Unprocessed',
    };

    // Prototype fake-door behavior for now.
    // eslint-disable-next-line no-console
    console.log('[Access Capital Fake Door]', payload);
    setSubmitted(true);
  };

  return (
    <div className={`${style.page} ${showBanner ? style.pageWithBanner : ''}`}>
      <h1 className={style.heading}>Help shape Access to Capital</h1>
      <p className={`${style.intro} ${style.introWide}`}>
        Access to Capital is not live in Chaser yet, but we are exploring it. Help us shape what it should look like.
      </p>

      <div className={`${style.panel} ${style.panelWide}`}>
        {submitted ? (
          <>
            <h2 className={style.doneTitle}>Thanks for your input</h2>
            <p className={style.doneText}>
              Your responses were captured and shared with the product team.
            </p>
          </>
        ) : (
          <form onSubmit={onSubmit}>
            <p className={style.question}>
              Are you currently using an access to capital or invoice finance provider?
            </p>
            <div className={style.row}>
              {['Yes', 'No', 'Not sure'].map(option => (
                <label key={option} className={style.chip}>
                  <input
                    type="radio"
                    name="usingProvider"
                    value={option}
                    checked={usingProvider === option}
                    onChange={(e) => setUsingProvider(e.target.value)}
                  />
                  <span>{option}</span>
                </label>
              ))}
            </div>

            {usingProvider === 'Yes' && (
              <input
                className={style.input}
                value={providerName}
                onChange={(e) => setProviderName(e.target.value)}
                placeholder="Which provider?"
              />
            )}

            <p className={style.question}>
              If Chaser offered access to capital tools, would you prefer to use them here rather than through your accounting system?
            </p>
            <div className={style.row}>
              {['Yes', 'No', 'Maybe'].map(option => (
                <label key={option} className={style.chip}>
                  <input
                    type="radio"
                    name="preferInChaser"
                    value={option}
                    checked={preferInChaser === option}
                    onChange={(e) => setPreferInChaser(e.target.value)}
                  />
                  <span>{option}</span>
                </label>
              ))}
            </div>

            <p className={style.question}>
              What would be most valuable to you from an access to capital feature? (select all that apply)
            </p>
            <div className={style.checklist}>
              {valuableOptions.map(option => (
                <label key={option} className={style.checkItem}>
                  <input
                    type="checkbox"
                    checked={valuable.includes(option)}
                    onChange={() => toggleValuable(option)}
                  />
                  <span>{option}</span>
                </label>
              ))}
            </div>

            <input
              className={style.input}
              value={otherValuable}
              onChange={(e) => setOtherValuable(e.target.value)}
              placeholder="Something else? Tell us..."
            />

            <button
              type="submit"
              className={`${style.submit} ${style.submitWithMargin} ${canSubmit ? '' : style.submitDisabled}`}
              disabled={!canSubmit}
            >
              Submit
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default CapitalPlaceholder;
